import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { CrmConfig } from '@frontend/sports/common/client-config-data-access';
import { firstValueFrom } from 'rxjs';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsApiService } from '../../services/my-bets-api.service';

export type MyBetsDetailsResponse =
    | {
          hasErrors: false;
          betslip: MyBetsBetSlip;
          associatedAccount: string | undefined;
      }
    | { hasErrors: true };

@Injectable()
export default class MyBetsDetailsResolver {
    constructor(
        private api: MyBetsApiService,
        private tokensConfig: CrmConfig,
    ) {}

    async resolve(route: ActivatedRouteSnapshot): Promise<MyBetsDetailsResponse> {
        const { betNumber } = route.params;
        const { associatedAccount } = route.queryParams;
        try {
            const response = await firstValueFrom(this.api.getSingleBetslip({ betslipId: betNumber, associatedAccount }));
            if (!response?.betslip) {
                return { hasErrors: true };
            }
            const betslip = MyBetsBetSlip.createFromBetslipResponse(response.betslip, {}, this.tokensConfig);

            return {
                hasErrors: false,
                betslip,
                associatedAccount,
            };
        } catch {
            return {
                hasErrors: true,
            };
        }
    }
}
